const CATEGORY = {
  1: { name: "건강", subcategories: {} },
  2: { name: "금융", subcategories: {} },
  3: { name: "교육", subcategories: {} },
  4: { name: "예술", subcategories: {} },
  5: { name: "커뮤니티", subcategories: {} },
};

export default CATEGORY;
